import { render, staticRenderFns } from "./todayAdoptManuscript.vue?vue&type=template&id=ab9359a8&scoped=true&"
import script from "./todayAdoptManuscript.vue?vue&type=script&lang=js&"
export * from "./todayAdoptManuscript.vue?vue&type=script&lang=js&"
import style0 from "./todayAdoptManuscript.vue?vue&type=style&index=0&id=ab9359a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9359a8",
  null
  
)

export default component.exports